import { useWorkspace } from '@/features/workspaces/hooks';
import { DataSourcesIcon } from '@/lib';
import { useGetWorkspaceMetricsQuery } from '@/services/endpoints/metrics';
import { FC } from 'react';
import { HomeDataSection } from '../../common';
import { DataSourcesDistributionChart } from './DataSourcesDistributionChart';

export const HomeDataSourceSection: FC = () => {
  const workspace = useWorkspace();
  const { data: metrics, isFetching } = useGetWorkspaceMetricsQuery(
    { workspaceId: workspace.id },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <HomeDataSection
      icon={<DataSourcesIcon />}
      title={'home:dataSourcesTitle'}
      totalLabel={'home:dataSourcesTotalLabel'}
      totalValue={metrics?.totalDataSourceSize}
      chart={<DataSourcesDistributionChart />}
      createPath={'/data-sources?catalog'}
      creteButtonText={'home:dataSourcesCreateButtonText'}
      isLoading={isFetching}
    />
  );
};
